export const publicCert = `-----BEGIN PUBLIC KEY-----
MIGbMBAGByqGSM49AgEGBSuBBAAjA4GGAAQAgzFkdyRevjQECOkwgaYeFlyCCr2o
rfVdfGYtbmbT4A/aSdFe2dr8MBrXHhyCS33TXTgt7hU4kk3F3MGiioG38hYAs4I0
8GsUjhygCLkxsw982b7sSAUkQGNYt9vHCnsv0F1IGuyIx950TmDI4ZREd4RnSRmF
HSMrdoo1a4ylQfX5WFQ=
-----END PUBLIC KEY-----`;
